module.exports = __webpack_public_path__ + "static/media/carpeta.f3ac67ff.gif";